module.exports = __webpack_public_path__ + "static/media/moving_to_heal_icon.3c54c826.svg";